// src/transliterator.js
import specialWords from './specialWords';

export const getOdiaCharacter = (currentChar, nextChar, prevOdiaChar) => {
  // Vowel signs (matra) mapping
  const vowelSigns = {
          // inherent vowel
    'a': 'ା',    // aa matra
    'i': 'ି',     // i matra
    'ii': 'ୀ',    // ii matra
    'u': 'ୁ',     // u matra
    'uu': 'ୂ',    // uu matra
    'e': 'େ',     // e matra
    'q':'ୋ',

//    'ai': 'ୈ',    // ai matra
    'o': 'ଓ',     // o matra
//    'au': 'ୌ',    // au matra
    //'ru': 'ୃ',    // ru matra  (୍)
    'f':'୍', // halanta (virama) for consonants
    //(୍ୱ) // 'w': '୍ୱ', // w matra (not used in modern Odia) 
    // (୍ର)// 'r': '୍ର', // r matra (not used in modern Odia)
    // 'l': '୍ଲ', // l matra (not used in modern Odia)
    // 's': '୍ସ', // s matra (not used in modern Odia)
    //'rb': 'ୃ', // ru matra (used in modern Odia)
    // 'ୖ', // special vowel sign for 'ru' (used in modern Odia)
    // 'ୗ', // special vowel sign for 'ru' (used in modern Odia)
    // '.', // dots 

    
  };

  // Independent vowels
  const vowels = {
    'a': 'ଅ', 'aa': 'ଆ', 'i': 'ଇ', 'ii': 'ଈ', 'u': 'ଉ',
    'uu': 'ଊ', 'e': 'ଏ', 'ai': 'ଐ', 'o': 'ଓ', 'au': 'ଔ',
    'ru': 'ଋ'
  };

  // Consonants
  const consonants = {
    'k': 'କ', 'K': 'ଖ', 'g': 'ଗ', 'G': 'ଘ', 'ng': 'ଙ',
    'c': 'ଚ', 'C': 'ଛ', 'j': 'ଜ', 'J': 'ଝ', 'ny': 'ଞ',
    't': 'ଟ', 'd': 'ଡ', 'D': 'ଢ', 'n': 'ଣ',
    'p': 'ପ', 'b': 'ବ', 'm': 'ମ', 
    'y': 'ୟ', 'r': 'ର', 'l': 'ଲ', 'A':'ଅ',
    //'v': 'ଭ', 
    's': 'ସ', 'S': 'ଶ', // Add this line: capital S = 'ଶ', small s = 'ସ'
//    'h': 'ହ', 
//    'tr': 'ତ୍ର', 'dr': 'ଦ୍ର', 'shch': 'ଶ୍ଚ',
  };

  // Special conjunct consonants
  const specialConjuncts = {
//    'ndh': 'ନ୍ଧ', 'nth': 'ନ୍ଥ', 'ngh': 'ନ୍ଘ', 'njh': 'ନ୍ଝ',
//    'nch': 'ନ୍ଛ', 'khy': 'କ୍ଷ', 'tr': 'ତ୍ର', 'dr': 'ଦ୍ର',
//    'shch': 'ଶ୍ଚ', 'sht': 'ଷ୍ଟ', 'shn': 'ଷ୍ଣ', 'sta': 'ସ୍ତ',
//    'sp': 'ସ୍ପ', 'sm': 'ସ୍ମ', 'sn': 'ସ୍ନ', 'sth':'ଷ୍ଠ',
  };
  // Merge specialWords into specialConjuncts for direct word mapping
  Object.assign(specialConjuncts, specialWords);

  // Numbers and punctuation
  const misc = {
    '.': '।', '..': '॥',
    '0': '୦', '1': '୧', '2': '୨', '3': '୩', '4': '୪',
    '5': '୫', '6': '୬', '7': '୭', '8': '୮', '9': '୯',
    //'am': 'ଂ',
  
  };

  // 1. Check for special conjuncts first
  for (const [key, value] of Object.entries(specialConjuncts)) {
    if (currentChar.startsWith(key)) {
      return { char: value, skip: key.length - 1 };
    }
  }

  // 2. Check misc characters
  for (const [key, value] of Object.entries(misc)) {
    if (currentChar.startsWith(key)) {
      return { char: value, skip: key.length - 1 };
    }
  }

  // 3. Check for vowel signs after consonants
  if (prevOdiaChar && !Object.values(vowelSigns).includes(prevOdiaChar.slice(-1))) {
    const sortedVowelKeys = Object.keys(vowelSigns).sort((a, b) => b.length - a.length);
    for (const key of sortedVowelKeys) {
      const value = vowelSigns[key];
      if (currentChar.startsWith(key)) {
        
        // Always allow 'ru' (ୃ) to be applied after consonants, even if followed by another consonant
        if (key === 'ru') {
          return { char: value, skip: key.length - 1 };
        }
        if (value) {
          return { char: value, skip: key.length - 1 };
        }
      }
    }
  }

  // 4. Check for consonant combinations
  
  // Sort consonant keys by length descending to match 'kh', 'gh', 'ch', etc. before 'k', 'g', 'c', etc.
  const sortedConsonantKeys = Object.keys(consonants).sort((a, b) => b.length - a.length);
  for (const key of sortedConsonantKeys) {
    const value = consonants[key];
    if (currentChar.startsWith(key)) {

      // Special handling: if next chars are 'ru', do not add halanta, just return consonant and let vowel sign logic handle 'ru'
      if (currentChar.slice(key.length, key.length + 2) === 'ru') 
        {
        return { char: value, skip: key.length - 1 };
      }

      // If next characters are a vowel sign (like 'i', 'ii', etc.), do NOT add halanta
      const vowelSignKeys = Object.keys(vowelSigns).sort((a, b) => b.length - a.length);
      for (const vkey of vowelSignKeys) {
        if (currentChar.slice(key.length).startsWith(vkey) && vowelSigns[vkey]) {
          return { char: value, skip: key.length - 1 };
        }
      }
      // If next character is a consonant, add halanta
      if (nextChar && ![ 'e', 'i', 'o', 'p', 's', 'x', 'X', 'G', 'c', 'C', 'J', 'y', ']', '[', 'M', 'z', 'V', ':', '@', '^', '&', '*', '£', '$', '(', ')', '#', '~', '`', '¬', 'Q', 'v','r','P', 'Z','S', 'L', 'l', 'K', 'b','g', 'h','t', 'l','d', ';', 'q','B','j', 'k','m', 'N','n', 'm','u'].includes(nextChar)) {
        return { char: value + '୍', skip: key.length - 1 };
      }
      return { char: value, skip: key.length - 1 };
    }
  }

  // 5. Check for independent vowels
  for (const [key, value] of Object.entries(vowels)) {
    if (currentChar.startsWith(key)) {
      return { char: value, skip: key.length - 1 };
    }
  }

  // 6. Check for special word mappings (case-insensitive)
  const lowerCurrent = currentChar.toLowerCase();
  for (const [key, value] of Object.entries(specialWords)) {
    if (lowerCurrent.startsWith(key.toLowerCase())) {
      return { char: value, skip: key.length - 1 };
    }
  }

  // Special case: handle 'krushna' and similar conjuncts
  if (currentChar.startsWith('krushna')) {
    return { char: 'କୃଷ୍ଣ', skip: 6 };
  }

  // Default case
  return { char: currentChar[0], skip: 0 };
};

// Accept specialWords as an argument for dynamic UI-managed mappings
export const transliterate = (text, specialWordsUI = []) => {
  let result = '';
  let i = 0;
  while (i < text.length) {
    // 1. Check UI-managed specialWords (regex or exact, case-insensitive)
    let matched = false;
    for (const sw of specialWordsUI) {
      if (sw.regex) {
        try {
          const re = new RegExp(sw.key, 'i');
          const m = re.exec(text.slice(i));
          if (m && m.index === 0) {
            result += sw.value;
            i += m[0].length;
            matched = true;
            break;
          }
        } catch (e) { /* ignore invalid regex */ }
      } else {
        if (text.slice(i).toLowerCase().startsWith(sw.key.toLowerCase())) {
          result += sw.value;
          i += sw.key.length;
          matched = true;
          break;
        }
      }
    }
    if (matched) continue;
    // Detect Shift+S (capital S) for 'ଶ', and 's' for 'ସ'
    if (text[i] === 'S') {
      result += 'ଶ';
      i++;
      continue;
    }
    if (text[i] === 's') {
      result += 'ସ';
      i++;
      continue;
    }
    // Detect Shift+N (capital N) for 'ଣ', and 'n' for 'ନ'
    if (text[i] === 'N') {
      result += 'ଣ';
      i++;
      continue;
    }
    if (text[i] === 'n') {
      result += 'ନ';
      i++;
      continue;
    }
    // Detect Shift+D (capital D) for 'ଧ', and 'd' for 'ଦ'
    if (text[i] === 'D') {
      result += 'ଧ';
      i++;
      continue;
    }
    if (text[i] === 'd') {
      result += 'ଦ';
      i++;
      continue;
    }
    
    // Detect Shift+D (capital H) for ' ', and 'h' for 'ହ'
    if (text[i] === 'H') {
      result += 'ଃ';
      i++;
      continue;
    }
    if (text[i] === 'h') {
      result += 'ହ';
      i++;
      continue;
    }

   // Detect Shift+C (capital C) for 'ଗ୍ଭ', and 'c' for 'ଚ'
    if (text[i] === 'C') {
      result += 'ଛ';
      i++;
      continue;
    }
    if (text[i] === 'c') {
      result += 'ଚ';
      i++;
      continue;
    }


    // Detect Shift+C (capital O) for '', and 'o' for ''
    if (text[i] === 'O') {
      result += 'ଔ';
      i++;
      continue;
    }
    if (text[i] === 'o') {
      result += 'ଓ';
      i++;
      continue;
    }



    
  // Detect Shift+C (capital X) for 'କ୍ଷ', and 'x' for ''
    if (text[i] === 'X') {
      result += 'କ୍ଷ';
      i++;
      continue;
    }
    if (text[i] === 'x') {
      result += 'ଷ';
      i++;
      continue;
    }

        // Detect Shift+C (capital V) for '', and 'v' for ''
    if (text[i] === 'V') {
      result += 'ଞ୍ଚ';
      i++;
      continue;
    }
    if (text[i] === 'v') {
      result += 'ଯ';
      i++;
      continue;
    }


    // Detect Shift+C (capital $) for '$', and '4' for ''
    if (text[i] === '$') {
      result += 'ଋ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+C (capital ^) for '', and '6' for '6'
    if (text[i] === '^') {
      result += 'ଗ୍ଭ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

  // Detect Shift+C (capital 'w') for '', and 'w' for ''
    if (text[i] === 'W') {
      result +='୍ର';
      i++;
      continue;
    }
    if (text[i] === 'w') {
      result += '୍ୱ';
      i++;
      continue;
    }

   // Detect Shift+C (capital 'M') for 'ଂ', and 'w' for ''
    if (text[i] === 'M') {
      result +='ଂ';
      i++;
      continue;
    }
    if (text[i] === 'm') {
      result += 'ମ';
      i++;
      continue;
    }


    // Detect Shift+C (capital '#') for 'ୖ', and 'w' for ''
    if (text[i] === '~') {
      result +='ୖ';
      i++;
      continue;
    }
    if (text[i] === '#') {
      result += '୰';
      i++;
      continue;
    }


    // Detect Shift+L (capital L) for 'ଲ', and 'l' for 'ଳ'
    if (text[i] === 'L') {
      result += 'ଲ';
      i++;
      continue;
    }
    if (text[i] === 'l') {
      result += 'ଳ';
      i++;
      continue;
    }
    // Detect Shift+J (capital J) for 'ଝ', and 'j' for 'ଜ'
    if (text[i] === 'J') {
      result += 'ଝ';
      i++;
      continue;
    }
    if (text[i] === 'j') {
      result += 'ଜ';
      i++;
      continue;
    }
    // Detect Shift+G (capital G) for 'ଘ', and 'g' for 'ଗ'
    if (text[i] === 'G') {
      result += 'ଘ';
      i++;
      continue;
    }
    if (text[i] === 'g') {
      result += 'ଗ';
      i++;
      continue;
    }

    // Detect Shift+G (capital @) for 'ଁ', and ''' for ''
    if (text[i] === '@') {
      result += 'ଁ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+G (capital '£') for '', and ''' for ''
    if (text[i] === '£') {
      result += 'ଐ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }


    // Detect Shift+T (capital T) for 'ଟ', and 't' for 'ତ'
    if (text[i] === 'T') {
      result += 'ଟ';
      i++;
      continue;
    }
    if (text[i] === 't') {
      result += 'ତ';
      i++;
      continue;
    }
    // Detect Shift+Y (capital Y) for '୍ୟ', and 'y' for 'ୟ'
    if (text[i] === 'Y') {
      result += '୍ୟ';
      i++;
      continue;
    }
    if (text[i] === 'y') {
      result += 'ୟ';
      i++;
      continue;
    }
    // Detect Shift+Y (capital I) for 'ଇ', and 'i' for 'ଇ'
    if (text[i] === 'I') {
      result += 'ଇ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+Y (capital E) for 'ଏ', and 'i' for 'ଇ'
    if (text[i] === 'E') {
      result += 'ଏ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }
    // Detect Shift+Y (capital A) for 'ଆ', and 'a' for 'ା'
    if (text[i] === 'A') {
      result += 'ଆ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+Y (capital U) for 'ଉ', and 'u' for ''
    if (text[i] === 'U') {
      result += 'ଉ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+Y (capital R) for 'ଋ', and '' for ''
    if (text[i] === 'R') {
      result += 'ୃ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+Y (capital P) for 'ଫ', and 'p' for 'ପ'
    if (text[i] === 'P') {
      result += 'ଫ';
      i++;
      continue;
    }
    if (text[i] === 'p') {
      result += 'ପ';
      i++;
      continue;
    }
    
    // Detect Shift+Y (capital B) for 'ଭ', and 'b' for 'ବ'
    if (text[i] === 'B') {
      result += 'ଭ';
      i++;
      continue;
    }
    if (text[i] === 'b') {
      result += 'ବ';
      i++;
      continue;
    }

    // Detect Shift+Y (capital O) for 'ୌ', and 'o' for ''
    if (text[i] === 'O') {
      result += 'ୌ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+Y (capital '*' ) for 'ଈ', and 'o' for ''
    if (text[i] === '*') {
      result += 'ଈ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }

    // Detect Shift+Y (capital '&' ) for 'ଊ', and 'o' for ''
    if (text[i] === '&') {
      result += 'ଊ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }



    // Detect Shift+Y (capital ¬) for '', and '`' for ''
    if (text[i] === '¬') {
      result += 'ୌ';
      i++;
      continue;
    }
    if (text[i] === '`') {
      result +=  'ତ୍ତ';
      i++;
      continue;
    }

    // Detect Shift+Y (capital Q) for 'ଢ', and 'q' for ''
    if (text[i] === 'Q') {
      result += 'ଠ';
      i++;
      continue;
    }
    if (text[i] === 'q') {
      result += 'ୋ';
      i++;
      continue;
    }

    // Detect Shift+Y (capital '' ) for '', and '' for ''
    if (text[i] === '{') {
      result += 'ଡ଼';
      i++;
      continue;
    }
    if (text[i] === '[') {
      result += 'ଡ';
      i++;
      continue;
    }

    // Detect Shift+Y (capital '}' ) for 'ଢ଼', and ']' for 'ଡ଼'
    if (text[i] === '}') {
      result += 'ଢ଼';
      i++;
      continue;
    }
    if (text[i] === ']') {
      result += 'ଢ'
      i++;
      continue;
    }


    // Detect Shift+Y (capital :) for ':', and ';' for ';'
    if (text[i] === ':') {
      result += ':';
      i++;
      continue;
    }
    if (text[i] === ';') {
      result += '.';
      i++;
      continue;
    }

    // Detect Shift+Y (capital :) for '{', and ';' for ''
    if (text[i] === '{') {
      result += '{';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }



      // Detect Shift+Y (capital Z) for 'ଙ', and 'z' for 'ଞ'
    if (text[i] === 'Z') {
      result += 'ଙ';
      i++;
      continue;
    }
    if (text[i] === 'z') {
      result += 'ଞ';
      i++;
      continue;
    }
    // Detect Shift+Y (capital P) for 'ଫ', and 'p' for 'ପ'
    if (text[i] === 'P') {
      result += 'ଫ';
      i++;
      continue;
    }
    if (text[i] === 'z') {
      result += 'ପ';
      i++;
      continue;
    }

        // Detect Shift+Y (capital 'F' ) for 'ଥ', and 'f' for 'halant'
    if (text[i] === 'F') {
      result += 'ଥ';
      i++;
      continue;
    }
    if (text[i] === '') {
      result += '';
      i++;
      continue;
    }



    // Detect Shift+K (capital K) for 'ଖ', and 'k' for 'କ'
    if (text[i] === 'K') {
      result += 'ଖ';
      i++;
      continue;
    }
    if (text[i] === 'k') {
      result += 'କ';
      i++;
      continue;
    }
    const lowerText = text.slice(i).toLowerCase();
    const nextChar = i + 1 < text.length ? text[i + 1] : null;
    const prevOdiaChar = result.slice(-1);
    // Skip spaces and add directly
    if (text[i] === ' ') {
      // If previous char was 'r' and last Odia char is 'ର୍', replace with 'ର'
      if (i > 0 && text[i-1] === 'r' && result.slice(-1) === '୍' && result.slice(-2, -1) === 'ର') {
        result = result.slice(0, -1); // Remove halanta
      }
      result += ' ';
      i++;
      continue;
    }

    // Get the Odia character
    const { char, skip } = getOdiaCharacter(lowerText, nextChar, prevOdiaChar);
    result += char;
    i += 1 + skip;
  }
  return result;
};